<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="columns">
          <div class="column">
            <figure class="image">
              <img src="../assets/royalty-free-wings.jpg" alt="Just a royalty free hot wing photo">
              <span>Royalty free photo of some wings</span>
            </figure>
          </div>
          <div class="column">
            <article class="message is-large is-warning">
              <div class="message-header">Stay Tuned!</div>
              <div class="message-body">
                <p>
                I'm jumping into this head first and have no idea what this project will turn into, but the goal is to help you find your favorite wings in Atlanta!
                </p>
              </div>
            </article>
          </div>
        </div>
        <section class="section align-left">
          <h5 class="title is-5">While I build this out, you may be interested in the following:</h5>
          <ul>
            <li> > <a href="https://www.reddit.com/r/Atlanta/comments/8alkwf/atlhotwingscom_i_need_your_input/" target="new">My post on r/atlanta looking for input on this site (add your ideas!)</a></li>
            <li> > <a href="https://calendar.google.com/calendar/embed?src=pk2sovnjfivl6ltfpm3g9jusos%40group.calendar.google.com&ctz=America%2FNew_York" target="new">My wing deal calendar, not extensive but might be of interest to folks ITP</a></li>
            <li> > <a href="http://www.foodiebuddha.com/#wings" target="new">FoodieBudda's suggestions for wings in ATL</a></li>
            <li> > <a href="https://www.instagram.com/wingsofatl/" target="new">Instagram: @wingsofatl</a></li>
          </ul>
        </section>
      </div>
    </section>
    <!-- <ContactForm/> -->
  </div>
</template>

<script>
import ContactForm from "./ContactForm";
export default {
  name: "Home",
  data() {
    return {};
  },
  components: {
    ContactForm
  }
};
</script>

<style scoped>
.hero {
  text-align: center;
}
.align-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue